module.exports = __webpack_public_path__ + "static/media/52786720_2452983574776819_5346182995785023488_o.2001974a.jpg";